import { Alert } from '@material-ui/lab'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  alert: {
    alignItems: 'center',
    // Override DialogActions padding
    margin: theme.spacing(-2, -3, 2),
  },
}))

type ModalErrorProps = {
  message?: string
}

const ModalError = ({
  message = 'Unable to save changes. Please check your network connection or try again later.',
}: ModalErrorProps) => {
  const classes = useStyles()

  return (
    <Alert
      severity="error"
      className={classes.alert}
    >
      {message}
    </Alert>
  )
}

export default ModalError
